<template>
    <div id="star" class="index relative">

        <div class="star relative" :style="{paddingTop: paddingTop + 'px'}">

            <img class="star-title" src="../../assets/images/star_img_title@2x.png" />

            <div class="content">

                <div
                    :id="key"
                    :ref="key"
                    class="star-model"
                    v-for="(value,key,index) in starList"
                    :key="'star-model-'+index"
                >

<!--                    {{key}},{{value}},{{index}}-->
                    <div class="star-model-title">

                        <title-line
                            :width="154"
                            :height="27"
                            backgroundColor="#C5C5C5"
                        >

                            <div class="line-title-text">{{key}}</div>

                        </title-line>

                    </div>

                    <div class="star-model-content">

                        <star-avatar-item
                            :width="160"
                            :height="160"
                            class="star-item"
                            v-for="(cItem,cIndex) in value"
                            :key="'star-item-'+cIndex"
                            :data="cItem"
                        />

                    </div>

                </div>

            </div>


            <div
                class="absolute star-index"
                :style="{top: top + 'px'}"
                id="star-index"
                ref="starIndex"
            >

                <div
                    class="star-index-item"
                    :class="[selected == index ? 'activeItem' : '']"
                    v-for="(item,index) in letterList"
                    :key="'star-index-item-'+index"
                    @click="scrollAnchorPoint(item,index)"
                >

                    {{ item }}

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import TitleLine from '../../layout/lineTitle/main';
import StarAvatarItem from '../../layout/starAvatarItem/main';

import mixin from "./mixin/mixin";
export default {
    name: "star",
    components: {
        TitleLine,
        StarAvatarItem
    },
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
